<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Campanha">
        <NxSelectCampanha @update:value="handleSelectUpdate('campanha', $event, false)"/>
        <NxSelectCampanhaCanal @update:value="handleSelectUpdate('canalId', $event, false)"/>
        <NxSelectCampanhaModelo @update:value="handleSelectUpdate('modeloId', $event, false)"/>
        <NxSelectCampanhaLista @update:value="handleSelectUpdate('listaId', $event, false)"/>
        <NxSelectCampanhaSituacao @update:value="handleSelectUpdate('situacaoId', $event, false)"/>
      </SearchCollapse>

      <SearchCollapse title="Datas">
        <NxInputDateRange
        label="Período de Criação:"
        @update:InitialValue="handleInputDateUpdate('dataCriacaoInicial', $event, false)"
        @update:FinalValue="handleInputDateUpdate('dataCriacaoFinal', $event, false)"
        />
        <NxInputDateRange
        label="Período de Envio:"
        @update:InitialValue="handleInputDateUpdate('dataEnvioInicial', $event, false)"
        @update:FinalValue="handleInputDateUpdate('dataEnvioFinal', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import {NxSelectCampanhaSituacao, NxSelectCampanhaLista, NxSelectCampanhaModelo, NxSelectCampanha, NxSelectCampanhaCanal} from '@/components/nexum/components/custom-selects/index.js'
import {NxInputDateRange} from '@/components/nexum/components/custom-inputs/index.js'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectCampanhaSituacao, NxSelectCampanhaLista, NxSelectCampanha, NxSelectCampanhaModelo, NxSelectCampanhaCanal, NxInputDateRange },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        campanha: null,
        canalId: null,
        listaId: null,
        modeloId: null,
        situacaoId: null,
        dataCriacaoFinal: null,
        dataCriacaoInicial: null,
        dataEnvioFinal: null,
        dataEnvioInicial: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/campanha/campanhaGeral/search/SidebarRelatorioCampanhaGeral.vue